import { connect } from 'react-redux';
import { actions } from "./AvailableRolesActions";
import AvailableRoles from './AvailableRoles';

const mapStateToProps = (state) => {
  const allRoles = state.AvailableRoles.allRolesList || {};
  return {
    allRoles,
  };
};

export default connect(mapStateToProps, actions)(AvailableRoles);